import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '../../components/Dialog';
import Input from '../../components/Input';
import Select from '../../components/Select';
import Button from '../../components/Button';
import Checkbox from '../../components/Checkbox';
import Table from '../../components/Table';

export default function VendorTabsDialog({
  open,
  form,
  setForm,
  options,
  onClose,
  onSubmit,
  editing,
  suppliersList = [],
  selectedSuppliers = ''
}) {
  const [activeTab, setActiveTab] = useState('vendor');
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
  if (!open) {
    setSelectedIds([]);
    setSelectAll(false);
    return;
  }

  if (form.suppliers === '*') {
    // zaznacz wszystkich
    setSelectedIds(suppliersList.map(s => String(s.id)));
    setSelectAll(true);
  } else if (form.suppliers) {
    const ids = form.suppliers.split(';').map(String);
    setSelectedIds(ids);
    setSelectAll(ids.length === suppliersList.length);
  } else {
    setSelectedIds([]);
    setSelectAll(false);
  }
}, [open, form.suppliers, suppliersList]);
const toggleSupplier = (id) => {
  setSelectedIds(prev => {
    const newSelected = prev.includes(id)
      ? prev.filter(x => x !== id)
      : [...prev, id];
    setSelectAll(newSelected.length === suppliersList.length);

    // zapis do form
    setForm(f => ({ ...f, suppliers: newSelected.map(String).join(';') }));

    return newSelected;
  });
};

const toggleSelectAll = () => {
  if (selectAll) {
    setSelectedIds([]);
    setSelectAll(false);
    setForm(f => ({ ...f, suppliers: '' }));
  } else {
    const allIds = suppliersList.map(s => s.id);
    setSelectedIds(allIds);
    setSelectAll(true);
    setForm(f => ({ ...f, suppliers: allIds.map(String).join(';') }));
  }
};
const handleSubmit = () => {
  const fullForm = {
    ...form,
    suppliers: selectedIds.map(String).join(';') // konwersja na string
  };
  onSubmit(fullForm);
};
  const handleSaveSuppliers = () => {
    setForm(v => ({ ...v, suppliers: selectedIds.join(';') }));
    setActiveTab('vendor'); // wracamy do zakładki formularza
  };

  const supplierColumns = [
    {
      field: 'select',
      headerName: '',
      width: 40,
      renderCell: ({ row }) => (
        <Checkbox
          checked={selectedIds.includes(row.id)}
          onCheckedChange={() => toggleSupplier(row.id)}
          size="small"
        />
      ),
    },
    {
      field: 'int_name',
      headerName: 'Nazwa dostawcy',
      renderCell: ({ row }) => (
        <div
          onClick={() => toggleSupplier(row.id)}
          className="cursor-pointer select-none hover:text-primary-600 transition-colors"
        >
          {row.int_name}
        </div>
      ),
    },
    {
      field: 'int_site',
      headerName: 'Strona',
      renderCell: ({ row }) => (
        <a href={row.int_site} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
          Przejdź
        </a>
      ),
    },
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogTitle>
        {editing ? 'Edycja dystrybutora' : 'Nowy dystrybutor'}
      </DialogTitle>
      <DialogContent>
        {/* 🔹 Tabs */}
        <div className="flex border-b border-gray-300 mb-4">
          <button
            className={`px-4 py-2 ${activeTab === 'vendor' ? 'border-b-2 border-blue-500 font-medium' : ''}`}
            onClick={() => setActiveTab('vendor')}
          >
            Formularz
          </button>
          <button
            className={`px-4 py-2 ${activeTab === 'suppliers' ? 'border-b-2 border-blue-500 font-medium' : ''}`}
            onClick={() => setActiveTab('suppliers')}
          >
            Dostawcy
          </button>
        </div>

        {/* 🔹 Zakładka formularza */}
        {activeTab === 'vendor' && (
          <div className="space-y-4 mt-2">
            <div className="md:flex gap-4">
              <Input size="small" label="Nazwa firmy" value={form.CompnyName || ''} onChange={e => setForm(v => ({ ...v, CompnyName: e.target.value }))} fullWidth />
              <Input size="small" label="Osoba odpowiedzialna" value={form.CompanyPerson || ''} onChange={e => setForm(v => ({ ...v, CompanyPerson: e.target.value }))} fullWidth />
            </div>
            <div className="md:flex gap-4">
              <Input size="small" label="NIP" value={form.CompanyNIP || ''} onChange={e => setForm(v => ({ ...v, CompanyNIP: e.target.value }))} fullWidth />
              <Input size="small" label="Numer telefonu" value={form.CompanyPhone || ''} onChange={e => setForm(v => ({ ...v, CompanyPhone: e.target.value }))} fullWidth />
            </div>
            <div className="md:flex gap-4">
              <Input size="small" label="Adres email" value={form.CompanyEmail || ''} onChange={e => setForm(v => ({ ...v, CompanyEmail: e.target.value }))} fullWidth />
              <Select
                size="small"
                label="Typ dystrybutora"
                value={form.atId || ''}
                onChange={e => setForm(v => ({ ...v, atId: e.target.value }))}
                fullWidth
                options={options.acountsType.map(c => ({ value: c.id, label: c.at_name }))}
              />
            </div>
            <div className="md:flex gap-4">
              <Input size="small" label="Procent kwoty od sztuki" value={form.value_for_one || '12.52'} onChange={e => setForm(v => ({ ...v, value_for_one: e.target.value }))} fullWidth />
              <Input size="small" label="Marketing (100 sztuk)" value={form.percent || '5.5'} onChange={e => setForm(v => ({ ...v, percent: e.target.value }))} fullWidth />
            </div>
          </div>
        )}

        {/* 🔹 Zakładka dostawców */}
        {activeTab === 'suppliers' && (
          <div className="overflow-x-auto mt-2">
            <div className="mb-4">
              <div className="flex items-center space-x-2">
                <Checkbox checked={selectAll} onCheckedChange={toggleSelectAll} />
                <span className="text-sm font-medium cursor-pointer" onClick={toggleSelectAll}>
                  Zaznacz wszystkich
                </span>
              </div>
              <p className="text-xs text-gray-500 mt-1">
                Zaznaczenie tej opcji wybierze wszystkich dostępnych dostawców.
                Klikając na nazwę dostawcy możesz zmienić jego zaznaczenie.
              </p>
            </div>
            <Table columns={supplierColumns} data={suppliersList} />
           
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button size="small" type="button" onClick={onClose} variant="outlined">Anuluj</Button>
      
          <Button size="small" type="button" onClick={handleSubmit} variant="contained" color='success'>Zapisz</Button>
      
      </DialogActions>
    </Dialog>
  );
}
